import React, { FC } from 'react'

import { InfoBlock } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { IPartnerDuplicatesHeaderProps } from './models'

import styles from './PartnerDuplicatesHeader.module.scss'

export const PartnerDuplicatesHeader: FC<IPartnerDuplicatesHeaderProps> = ({
  searchResultCount,
  hasSamePartner,
  headerActions,
  headerMessages,
}) => (
  <div>
    <div className={styles.header}>
      <div className={styles.header_titleContainer}>
        <div className={styles.header_title}>
          {/* Apollo Result Search */}
          <Translation text={'partner-apollo-search-result'} span />:
        </div>
        <div>
          {/* companies found */}
          {searchResultCount} <Translation text={'partner-apollo-companies-found'} span />
        </div>
      </div>
      <div>
        <div className={styles.header_buttonContainer}>
          {headerActions
            .filter((button) => button.checkVisibility({ hasSamePartner }))
            .map((button) => (
              <Button key={button.title} onClick={button.onClick}>
                <Translation text={button.title} span />
              </Button>
            ))}
        </div>
      </div>
    </div>
    <div className={styles.header_text}>
      {headerMessages
        .filter((message) => message.checkVisibility({ hasSamePartner }))
        .map((message, key) => (
          <InfoBlock key={key} text={message.message} type={message.type} />
        ))}
    </div>
  </div>
)
